import React from 'react';

const TableLoader = () => {
  return (
    <div className="text-center py-4">
      <div className="spinner-border text-info" role="status">
        <span className="visually-hidden">Carregando...</span>
      </div>
      <p className="text-secondary mt-2 mb-0">Carregando dados...</p>
    </div>
  );
};

export default TableLoader; 